import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  title: string;
  index: number;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, index, children }) => {
  const indexLabel = `[${String(index).padStart(2, '0')}] / ${title.toUpperCase()}`;

  return (
    <motion.section
      className="scroll-mt-24"
      initial={{ opacity: 0, y: 6 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-[11px] font-mono tracking-[0.18em] text-neutral-500 dark:text-neutral-500">
            {indexLabel}
          </span>
          <div className="flex-1 h-px bg-neutral-200 dark:bg-neutral-800" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-sans font-medium tracking-tight text-neutral-900 dark:text-neutral-50">
          {title}
        </h2>
      </div>
      {children}
    </motion.section>
  );
};

export default Card;
